import * as React from "react";

import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button
} from "reactstrap";

import ReactTable from "react-table";
import { Column } from "react-table";

import "react-table/react-table.css";

import i18n from "i18n";

import { getAsync } from "utils/net";

export interface ExportDialogProps {
  isOpen: boolean;
  onCancel: () => void;
}
export interface ExportDialogState {
  selectAll: number;
  data: Data[];
}

export default class ExportDialog extends React.Component<
  ExportDialogProps,
  ExportDialogState
  > {
  constructor(props: ExportDialogProps) {
    super(props);
    this.state = { selectAll: 0, data: [] };
    this.toggleRow = this.toggleRow.bind(this);
  }

  async componentDidUpdate(prevProps: ExportDialogProps) {
    if (prevProps.isOpen === this.props.isOpen || !this.props.isOpen) {
      return;
    }

    const reply = await getAsync("/api/designer/getscenarios");
    const scenarios = await reply.json();

    let data = scenarios.map((s: any) => ({ scenario: s, selected: false }));
    this.setState({
      data: data
    });
  }

  private getCheckBox(row: any) {
    return (
      <input
        type="checkbox"
        className="checkbox"
        checked={row.original.selected}
        onChange={() => this.toggleRow(row.original)}
      />
    );
  }

  private getHeaderCheckbox(row: any) {
    return (
      <input
        type="checkbox"
        className="checkbox"
        checked={this.state.selectAll === 1}
        ref={input => {
          if (input) {
            input.indeterminate = this.state.selectAll === 2;
          }
        }}
        onChange={() => this.toggleSelectAll()}
      />
    );
  }

  render() {
    const columns: Column[] = [
      {
        id: "checkbox",
        accessor: "",
        Cell: this.getCheckBox.bind(this),
        Header: this.getHeaderCheckbox.bind(this),
        sortable: false,
        width: 45
      },
      {
        Header: i18n.Scenarios.Table.Name,
        accessor: "scenario.partitionKey"
      },
      {
        Header: i18n.Scenarios.Table.Category,
        accessor: "scenario.category",
      },
      {
        Header: i18n.Scenarios.Table.Market,
        accessor: "scenario.market"
      },
      {
        Header: i18n.Scenarios.Table.Type,
        accessor: "scenario.type"
      }
    ];

    return (
      <Modal
        isOpen={this.props.isOpen}
        size="lg"
      >
        <ModalHeader>
          {i18n.Scenarios.ExportDialog.Title}
        </ModalHeader>
        <ModalBody>
          <ReactTable
            data={this.state.data}
            columns={columns}
            defaultPageSize={10}
          />
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={() => this.onSave()}
          >
            {i18n.Scenarios.ExportDialog.ExportButton}
          </Button>
          <Button
            color="default"
            onClick={() => this.props.onCancel()}
          >
            {i18n.Global.Edit.Cancel}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }

  private toggleRow(row: Data) {
    row.selected = !row.selected;

    let noneChecked = true;
    let allChecked = true;

    this.state.data.forEach((value: Data) => {
      if (value.selected) {
        noneChecked = false;
      } else {
        allChecked = false;
      }
    })

    let selectAll = 2;
    if (noneChecked) {
      selectAll = 0;
    } else if (allChecked) {
      selectAll = 1;
    }

    this.setState({
      data: this.state.data.slice(),
      selectAll: selectAll
    });
  }

  private toggleSelectAll() {
    if (this.state.selectAll === 0) {
      this.state.data.forEach(x => x.selected = true);
    } else {
      this.state.data.forEach(x => x.selected = false);
    }

    this.setState({
      data: this.state.data.slice(),
      selectAll: this.state.selectAll === 0 ? 1 : 0
    });
  }

  private onSave() {
      let a = document.createElement("a");
      let scenariosJson = JSON.stringify(this.state.data.filter(d => d.selected).map(d => d.scenario));
      let blobObj = new Blob([scenariosJson], { type: "text/plain" })
      let blobUrl = URL.createObjectURL(blobObj)
      a.href = blobUrl
      a.download = "scenarios.json";
      a.target = "_blank";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      this.props.onCancel();
  }
}

class Data {
  scenario: any;
  selected: boolean;
}



// WEBPACK FOOTER //
// ./src/designer/exportimport/exportdialog.tsx